import identity_cards from "@/config/identity/identity_cards";
export function isDocValid(type: string, number: string): boolean {
  // Паспорт РФ
  if (type == "0") if (number.match(/^\d{10}$/)) return true;

  return false;
}

// Паспорт РФ
export function isValidPassport(passport: string): boolean {
  // Проверяем форматы: 1234567890, 12 34 567890, 12-34-567890
  const cleaned = passport.replace(/\D/g, "");
  const regex = /^(\d{2})[\s-]?(\d{2})[\s-]?(\d{6})$/;
  const match = cleaned.match(regex);
  if (!match) return false;

  const [_, part1, part2, part3] = match;

  // Проверяем, что номер не 000000
  if (part3 === "000000") return false;

  // Проверяем, что регион в допустимом диапазоне (01–99)
  const regionCode = parseInt(part1);
  const isRegionValid = regionCode >= 1 && regionCode <= 99;
  if (!isRegionValid) return false;

  return true;
}

// Свидетельство о рождении
export function isValidBirthCertificate(certificate: string): boolean {
  const oldFormat = /^[IVXLCDM]+[- ][А-ЯЁ]{2}[- ]*№?\s*\d{6}$/i;
  const newFormat = /^[A-Z]{2}[- ]?\d{6}$/i;
  const all = /^[IVCLX1УХЛС]{0,4}[А-ЯЁ]{2}\d{6}$/; //?

  const cleaned = certificate.trim();
  return (
    oldFormat.test(cleaned) || newFormat.test(cleaned) || all.test(cleaned)
  );
}

// Паспорт моряка
export function isValidSeamanPassport(passport: string): boolean {
  // Удаляем пробелы/дефисы и приводим к верхнему регистру
  const cleaned = passport.replace(/[\s-]+/g, "").toUpperCase();
  // Проверяем формат: RUS + 2 буквы + 6 цифр
  return /^RUS[A-Z]{2}\d{6}$/.test(cleaned);
}
